(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-header"]) return;
  try {
    
 
$(document).ready(function(){
  if($( window ).width() <= 767){

    $('header .hamburger').show();
    $('.hamburger').on('click', function(){
      $(this).toggleClass('cross_button');
      $('.header_navigation_section').slideToggle();
    })
    
    $('.header_navigation_section .menu_heading').on('click', function(){
      $(this).toggleClass('rotate');
      $(this).parent().siblings().find('.menu_heading').removeClass('rotate');
      $(this).parent().siblings().find('.header_menu_list').hide();
        $(this).siblings().slideToggle(); 
    })

    $(document).on('click','.header_top_section .search_div svg',function(e){
      e.preventDefault();
     $(this).closest('.search_div').toggleClass('active'); 
})
  }
})
  

  } catch(e) { console.error(e); }
})();
})();
